import { createTheme } from '@mui/material/styles';
import { scGray5, scWhite } from 'constants/systemColors';
import { muiThemeLocales } from 'services/i18n/mui';

const whiteHeaderTheme = createTheme(
  {
    palette: {
      primary: {
        main: '#691E44'
      },
      DataGrid: {
        bg: scWhite,
        headerBg: scWhite,
        pinnedBg: scWhite
      }
    },
    components: {
      MuiButtonBase: {
        styleOverrides: {
          root: {
            ':focus': {
              outline: 'none'
            }
          }
        }
      },
      MuiChip: {
        styleOverrides: {
          sizeSmall: {
            fontSize: '12px',
            fontWeight: '400',
            lineHeight: '18px'
          }
        }
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            '& .MuiDataGrid-scrollbar::-webkit-scrollbar-track': {
              backgroundColor: scGray5
            }
          }
        }
      }
    }
  },
  ...muiThemeLocales
);

export default whiteHeaderTheme;
